import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class ListaPrecioDetalleService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  obtenerPrecioCosto(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      producto_codigo: number
      formato_codigo: string
    }
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: lista_precio_detalleInputType) {
            lista_precio_detalle {
              obtenerPrecioCosto(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  empresa_rut
                  sucursal_codigo
                  precio_costo
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.lista_precio_detalle.obtenerPrecioCosto
        callback({ mensajes, respuesta })
      }
    );
  }

  guardarPrecioCosto(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation ($entidad: lista_precio_detalleInputType) {
          lista_precio_detalle {
            guardarPrecioCosto(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                precio_neto
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.lista_precio_detalle.guardarPrecioCosto
        callback({ mensajes, respuesta })
      }
    );
  }
}
